<!--
 * @Author: byliang2 byliang2@iflytek.com
 * @Date: 2023-06-07 15:12:52
 * @LastEditors: byliang2 byliang2@iflytek.com
 * @LastEditTime: 2024-02-27 00:24:47
 * @FilePath: \topze-web-one\src\components\TabTitle.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="tab">
    <div class="flex">
      <div class="title">{{ title }}</div>
      <p v-if="isShowTips">
        每个文件下载后，将为您保存72小时，点击
        <span class="donwload-btn">下载</span>
        即可重新下载;视频文件仅提供6小时保存时间，超时需重新付费
      </p>
    </div>

    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    isShowTips: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.tab {
  padding: 30px;
  background: white;
  margin-bottom: 20px;

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    font-size: 20px;
  }

  p {
    color: #909399;
  }
}

.donwload-btn {
  color: white;
  background-color: #f56c6c;
  padding: 2px 6px;
  border-radius: 3px;
  margin: 0 4px;
}
</style>
